export enum IntegrationType {
  Jira = "jira",
  SlackApp = "slack_app",
}

type IntegrationMeta = {
  project_key?: string;
  issue_name?: string;
};

export interface Integration {
  id?: number;
  name: string;
  type: IntegrationType;
  url: string;
  email: string;
  meta: IntegrationMeta;
}

export interface SlackAppIntegration {
  id?: number;
  type: IntegrationType;
  client_id: string;
  app_id: string;
  enterprise_name?: string;
  enterprise_url?: string;
  team_name: string;
  update_available: boolean;
}

export interface IntegrationBody extends Integration {
  token?: string;
}

export interface InvocationBody {
  issue_id: number;
}

export interface InvocationResponse {
  issue_key: string;
}

export interface SlackAppIntegrationGetResponse {
  deploymentId: string;
  client_id: string;
  app_id: string;
  enterprise_name?: string;
  enterprise_url?: string;
  team_name: string;
  update_available: boolean;
}

export interface SlackAppIntegrationDeletionResponse {
  deploymentId: string;
  client_id: string;
  app_id: string;
  team_name: string;
}

export interface SlackAppNotificationMapping {
  id: number;
  installation_id: number;
  deployment_id: number;
  deployment_slug: string;
  team_id: string;
  team_name: string;
  channel_id: string;
  channel_name: string;
  is_owner: boolean;
}

export interface SlackAppNotificationMappingsResponseBody {
  notification_mappings: SlackAppNotificationMapping[];
}

export interface SlackAppNotificationMappingRequestBody {
  channel_id: string;
}

export interface SlackAppNotificationMappingTestResponse {
  notification_mapping: SlackAppNotificationMapping;
  success: boolean;
}
